'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useEffect } from 'react';
import { Heading } from '../heading/heading.js';
import { ErrorSummaryContext } from './error-summary.js';

/**
 * ErrorSummary heading component, used to display a heading for the error summary.
 *
 * @example
 * <ErrorSummary>
 *   <ErrorSummaryHeading>Heading</ErrorSummaryHeading>
 * </ErrorSummary>
 */
const ErrorSummaryHeading = forwardRef(function ErrorSummaryHeading({ className, id, ...rest }, ref) {
    const { headingId, setHeadingId } = useContext(ErrorSummaryContext);
    useEffect(() => {
        if (id && headingId !== id)
            setHeadingId(id);
    }, [headingId, id, setHeadingId]);
    return jsx(Heading, { id: headingId, ref: ref, ...rest });
});

export { ErrorSummaryHeading };
